import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaFormFieldComponent, CaLabel } from '@global-front-components/ui/form-field';
import { CaInputDirective } from '@global-front-components/ui/input';
import { CaCardComponent } from '@global-front-components/ui/card';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'app-datos-complementarios',
	standalone: true,
	imports: [
		CommonModule,
		CaLabel,
		CaInputDirective,
		CaFormFieldComponent,    
		CaCardComponent,
		TranslateModule
	],	templateUrl: './datos-complementarios.component.html',
	styleUrls: ['./datos-complementarios.component.scss']
})
export class DatosComplementariosComponent {
	@Input() companiaProcedencia: string;
}
